export enum ConnectionStatus {
	Requested,
	Active,
	Deauthorized,
	Expired,
	Deleted,
}
